import { type CreateMaterialTypeInputType } from '@shelflix/schemas/materialType/create';
import { create } from 'zustand';

interface MaterialTypeFormStore {
  formData: Partial<CreateMaterialTypeInputType>;
  setFormData: (data: Partial<CreateMaterialTypeInputType>) => void;
  resetForm: () => void;
}

export const useMaterialTypeFormStore = create<MaterialTypeFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
